/**
 * Create System Setting context for custom hook
 */
import { createContext } from 'react'

const ProductsContext = createContext({
  fetchProduct: () => {}
})

export default ProductsContext
